import { Storage } from '@lightningjs/sdk';
import { getProfilesAvatars } from '../../../../api/profiles';
import ProfilePicture from '../components/ProfilePicture';

export default function (page) {
  return getProfilesAvatars().then(({ data }) => {
    Storage.set('create-profile', { profileImage: data[0].image_url, avatar_id: data[0].id });
    const profilePicture = [
      {
        type: ProfilePicture,
      },
    ];

    page._Picture.items = profilePicture;
  });
}
